/**
 * Build the /play-game URL for a CRM game object.
 * Launch needs prd_id (product); live tables also need table_id and
 * slots/mini games need game_id, so both ride along as query params.
 */
export function buildPlayGameUrl(game) {
  if (!game?.prd_id) return null;
  const params = new URLSearchParams();
  if (game.table_id) params.set("table", game.table_id);
  else if (game.game_id) params.set("game", game.game_id);
  if (game.category) params.set("category", game.category);
  if (game.name) params.set("name", game.name);
  const query = params.toString();
  return `/play-game/${game.prd_id}${query ? `?${query}` : ""}`;
}
